import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faMapMarkerAlt,
  faPhone,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import Style from "../Item/Item.module.css";
import Timer from "../Timer/Timer";
import { setDeliveringTimeApi } from "../../Api/DeliveryBarest";
import { errorToast } from "../../Utils/Toast/Toast";
import { Modal } from "antd";
// import Modal from "../Modal/Modal";

const SuppliersInfo = ({
  deliver,
  data,
  itemId,
  time,
  parentCallback,
  setPurchased,
  orderlist,
}) => {
  const [sortedData, setSortedData] = useState(data);
  const [code, setCode] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [disable, setDisable] = useState(false);
  const [supplierId, setSupplierId] = useState();

  ///////////////sort restaurant & supermarket///////////////////
  useEffect(() => {
    sortByAscending();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortedData]);

  const sortByAscending = () => {
    let sortedAsceding = sortedData.sort((b, a) => {
      return a.prepare_remaining_time > b.prepare_remaining_time ? -1 : 1;
    });
    setSortedData(sortedAsceding);
  };
  ////////////open modal of send delivery code//////
  const openModalFunc = (id) => {
    setOpenModal(true);
    setSupplierId(id);
  };
  ///////send delivering time/////////
  const sendTimeDelivering = () => {
    setDisable(true);
    let info = {
      id: itemId,
      supplier_id: supplierId,
      delivery_code: code,
    };
    setDeliveringTimeApi(info, (res) => {
      if (res.status === 1) {
        setDisable(false);
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        setDisable(false);
        errorToast(res.message);
      }
    });
  };
  ////send item id to parent //////
  const ordersList = (product) => {
    console.log(product);
    parentCallback(product);
    setPurchased(true);
  };
  return (
    <div>
      <Modal
        open={openModal}
        onCancel={() => setOpenModal(false)}
        style={{ direction: "rtl", fontFamily: "iran-sans-num" }}
        footer={null}
        destroyOnClose
        title="وارد کردن کد"
      >
        <div className={Style.modalHolder}>
          <input
            className={Style.codeInput}
            onChange={(e) => setCode(e.target.value)}
          />
          <button
            disabled={disable}
            onClick={sendTimeDelivering}
            className={Style.sendBtn}
          >
            ارسال
          </button>
        </div>
      </Modal>
      {sortedData.map((item, index) => {
        return (
          <div key={index} className={Style.foodInfo}>
            <div className={Style.date}>
              <h3 className={Style.textCode}>
                <FontAwesomeIcon className={Style.icon} icon={faStore} />
                {item.supplier_name}
              </h3>
            </div>
            <div className={Style.date}>
              <h3 className={Style.textCode}>
                <FontAwesomeIcon className={Style.icon} icon={faMapMarkerAlt} />
                {item.address}
              </h3>
            </div>
            <div className={Style.h3Holder}>
              {localStorage.getItem("type") === "android" ? (
                <h3 className={Style.goMap}>
                  <a
                    className={Style.showInMap}
                    href={`geo:${item.lon},${item.lat}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    نمایش آدرس در نقشه
                  </a>
                </h3>
              ) : null}
              {localStorage.getItem("type") === "ios" ||
              localStorage.getItem("type") === "desktop" ? (
                <h3 className={Style.goMap}>
                  <a
                    className={Style.showInMap}
                    href={`https://maps.apple.com/?q=${item.lat} + ${item.lon}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    نمایش آدرس در نقشه
                  </a>
                </h3>
              ) : null}
              {deliver && item.status === "1.1" ? (
                <h3
                  className={Style.deliver}
                  onClick={() => openModalFunc(item.id)}
                >
                  تحویل گرفتم
                </h3>
              ) : null}
            </div>
            <div className={Style.date}>
              <a href={`tel:${item.phone}`} className={Style.textCode}>
                <FontAwesomeIcon className={Style.icon} icon={faPhone} />
                {item.phone}
              </a>
            </div>
            {time ? (
              <div className={Style.date}>
                <h3 className={Style.textCode}>
                  <FontAwesomeIcon className={Style.icon} icon={faClock} />
                  مدت زمان آماده سازی :
                </h3>

                <span className={Style.timeReady}>
                  {item.prepare_remaining_time === "0" ? (
                    <>آماده شد</>
                  ) : (
                    <Timer Time={item.prepare_remaining_time} />
                  )}
                </span>
              </div>
            ) : null}

            {orderlist === false ? null : (
              <>
                {item.pay_more === "1" ? (
                  <p className={Style.notice}>
                    <sup style={{ color: "red" }}>**</sup>مشتری مبلغ پرداخت نشده
                    دارد<sup style={{ color: "red" }}>**</sup>
                  </p>
                ) : null}
                <button
                  className={Style.btnOrder}
                  onClick={() => ordersList(item)}
                >
                  لیست سفارش
                </button>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default SuppliersInfo;
